import { render } from "./blackListedSubs.vue?vue&type=template&id=c7ac1702"
import script from "./blackListedSubs.vue?vue&type=script&lang=js"
export * from "./blackListedSubs.vue?vue&type=script&lang=js"

import "./blackListedSubs.vue?vue&type=style&index=0&id=c7ac1702&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__